import React from 'react';
import { motion } from 'framer-motion';

export default function ShutdownScreen() {
  return (
    <motion.div
      className="shutdown-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className="shutdown-content">
        <div className="shutdown-logo">
          <div className="win95-flag small">
            <div className="flag-piece red"></div>
            <div className="flag-piece green"></div>
            <div className="flag-piece blue"></div>
            <div className="flag-piece yellow"></div>
          </div>
        </div>
        <h1>It's now safe to turn off</h1>
        <h1>your computer.</h1>
        <p className="shutdown-hint">(Or refresh the page to restart)</p>
      </div>
    </motion.div>
  );
}
